import { OUTLOOK_MF_INTRO, OUTLOOK_MF_SLUG } from '@/content/outlookManufacturing'
import { outlook } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The eleventh report with a designed page of its own, and the second Future
  // 2030 outlook — asked for on 2026-08-28, hours after the Automotive one
  // (*"referans alarak ilgili sayfayı birebir tıpa tıp aynısını tasarla"*) with a
  // five-part full-page capture of the live page and all six of the images it
  // carries. See `content/outlookManufacturing.ts` and
  // `pages/OutlookManufacturing.tsx`.
  ...outlook(
    OUTLOOK_MF_SLUG,
    'Manufacturing',
    undefined,
    'future-2030-outlook-manufacturing-cover',
    '89a8f819-3c0a-4992-98f2-14794dcade30-digitopia-report-outlook-manufacturing-2030.pdf',
  ),
  // The hero's own two lines, joined into one paragraph — same as the Automotive
  // entry above, and for the same reason: this page draws its hero from
  // `OUTLOOK_MF_INTRO` directly, so `body` feeds exactly one thing, the meta
  // description `prerender.tsx` takes from `body[0]`. The question alone is too
  // short to be one.
  body: [`${OUTLOOK_MF_INTRO.lede} ${OUTLOOK_MF_INTRO.body}`],
  layout: 'manufacturing-outlook',
  // Its own words, its cover, its file and all six of its images, so
  // `stillToCome` has nothing left to say about it. What is still open is
  // section-by-section on its page, and `outlookManufacturingChecks()` carries
  // that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 29
